<template>
    <div class="d-block text-nowrap"
         v-if="lastGames">
        <span v-for="(g, index) in lastGames"
              :key="index"
              class="px-1 text-center"
              :class="getClass(g)">{{g}}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            lastGames: Array
        },
        methods: {
            getClass(g) {
                if (g == 'S')
                    return 'border-success bg-success text-light'
                else if(g == 'N')
                    return 'border-danger bg-danger text-light'
                else
                    return 'border-warning bg-warning text-light'
            }
        }
    }
</script>